import React from "react";
import logger from "logger";
import { Menu, MenuItem, Tooltip } from "@material-ui/core";

import NestedMenuItem from "material-ui-nested-menu-item";
import "./index.css";
import WheelDialog from "./WheelDialog";
import ArcheryRangeDialog from "./ArcheryRangeDialog";
import GearSortDialog from "./GearSortDialog";

import UpgradeBuildingsDialog from "./UpgradeBuildingsDialog";
import UpgradeHeroDialog from "./UpgradeHeroDialog";
import SkillEnrollerDialog from "./SkillEnrollerDialog";
import UpgradeMountDialog from "./UpgradeMountDialog";
import CGBuffDialog from "./CGBuffDialog";
import ChestOpenDialog from "./ChestOpenDialog";
import ClaimRewardsDialog from "./ClaimRewardsDialog";
import TrainathonDialog from "./TrainathonDialog";
import WallRemoverDialog from "./WallRemoverDialog";
import TowerEventsDialog from "./TowerEventsDialog";
import ECHSDialog from "./ECHSDialog";
import GKDialog from "./GKDialog";
import EBKDialog from "./EBKDialog";
import EBKDialogV2 from "./EBKDialogV2";
import MiningDialog from "./MiningDialog";
import RecallMinesDialog from "./RecallMinesDialog";
import ShardStealerDialog from "./ShardStealerDialog";
import ReassignTroopsDialog from "./ReassignTroopsDialog";
import ReassignRssDialog from "./ReassignRssDialog";
import DownloadLBSDialog from "./DownloadLBSDialog";
import WorldBossDialog from "./WorldBossDialog";
import OpenSCHSMapsDialog from "./OpenSCHSMapsDialog";
import ECHSCustomRunDialog from "./ECHSCustomRunDialog";
import CHSCustomRunDialog from "./CHSCustomRunDialog";
import SCHSCustomRunDialog from "./SCHSCustomRunDialog";
import { showDialog } from "DialogProvider";
import { ToolbarButton } from "Common/ToolbarButton";

import "./index.css";

export default function(props) {
  const { accountdetailrow, AccountDetailData } = props;
  const [menuPosition, setMenuPosition] = React.useState(null);

  const dialogMap = {
    archeryrange: ArcheryRangeDialog,
    gearsort: GearSortDialog,
    wheel: WheelDialog,
    upgradebuildings: UpgradeBuildingsDialog,
    heroupgrader: UpgradeHeroDialog,
    skillenroller: SkillEnrollerDialog,
    upgrademounttomax: UpgradeMountDialog,
    cgbuff: CGBuffDialog,
    chestopen: ChestOpenDialog,
    claimrewards: ClaimRewardsDialog,
    tat: TrainathonDialog,
    wallremover: WallRemoverDialog,
    towerevents: TowerEventsDialog,
    echs: ECHSDialog,
    gkrun: GKDialog,
    ebkrun: EBKDialog,
    ebkv2run: EBKDialogV2,
    mining: MiningDialog,
    recallmines: RecallMinesDialog,
    shardstealer: ShardStealerDialog,
    reassignrss: ReassignRssDialog,
    reassigntroops: ReassignTroopsDialog,
    downloadlbsevents: DownloadLBSDialog,
    worldboss: WorldBossDialog,
    openschsmaps: OpenSCHSMapsDialog,
    echscustomrun: ECHSCustomRunDialog,
    chscustomrun: CHSCustomRunDialog,
    schscustomrun: SCHSCustomRunDialog,
  };

  const openDialog = (key) => {
    const Component = dialogMap[key];
    showDialog(<TaskDialog name={key} open={true} component={Component} />);
  };

  const closeDialog = (key) => {
    showDialog(null);
  };

  const handleMenuOpen = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.pageY,
      left: event.pageX,
    });
  };

  const handleMenuClose = () => {
    setMenuPosition(null);
  };

  const TaskDialog = (props) => {
    logger.log("TaskDialog", props);
    const { component: Component, name, ...rest } = props;
    return (
      <Component
        open={props.open}
        handleClose={() => closeDialog(name)}
        accountdetailrow={accountdetailrow}
        AccountDetailData={AccountDetailData}
        {...rest}
      />
    );
  };

  const TaskMenuButton = (props) => {
    const { name, label } = props;
    return (
      <MenuItem
        onClick={() => {
          openDialog(name);
          handleMenuClose();
        }}
      >
        {label}
      </MenuItem>
    );
  };

  const CustomNestedMenuItem = ({ label, children, ...rest }) => {
    return (
      <NestedMenuItem label={label} parentMenuOpen={!!menuPosition} {...rest}>
        {children}
      </NestedMenuItem>
    );
  };

  return (
    <>
      <ToolbarButton
        label={"Tasks"}
        tooltip={`Click to open tasks.`}
        onClick={handleMenuOpen}
      />
      <Menu
        open={!!menuPosition}
        onClose={handleMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
        id="taskmenu"
      >
        <CustomNestedMenuItem label="Wheel/Range">
          <TaskMenuButton name="wheel" label="Wheel" />
          <TaskMenuButton name="archeryrange" label="Archery Range" />
        </CustomNestedMenuItem>

        <CustomNestedMenuItem label="Upgrade/Build/Sort">
          <TaskMenuButton name="gearsort" label="Gear Sort" />
          <TaskMenuButton name="upgradebuildings" label="Upgrade Buildings" />
          <TaskMenuButton name="heroupgrader" label="Upgrade Hero" />
          <TaskMenuButton
            name="skillenroller"
            label="Enroll Skills on heroes"
          />
          <TaskMenuButton name="upgrademounttomax" label="Upgrade Mount" />
          <TaskMenuButton name="cgbuff" label="City Guardian" />
          <TaskMenuButton name="chestopen" label="Open Chests" />
          <TaskMenuButton
            name="claimrewards"
            label="Claim Event Center Rewards"
          />
        </CustomNestedMenuItem>

        <TaskMenuButton name="tat" label="Trainathon" />
        <TaskMenuButton
          name="wallremover"
          label="Assign to Wall remover service"
        />

        <CustomNestedMenuItem label="Tower">
          <TaskMenuButton name="towerevents" label="Sage Tower/LT Tower" />
        </CustomNestedMenuItem>

        <CustomNestedMenuItem label="ECHS/BK/GK/WB">
          <TaskMenuButton name="echs" label="ECHS Run" />
          <TaskMenuButton name="worldboss" label="World boss" />
          <TaskMenuButton name="gkrun" label="Goblin Kill" />
          <TaskMenuButton name="ebkrun" label="Elite Alliance Boss" />
          <TaskMenuButton
            name="ebkv2run"
            label="Alliance Boss Kill/Summon Advanced"
          />
        </CustomNestedMenuItem>

        <CustomNestedMenuItem label="Mining">
          <TaskMenuButton name="mining" label="Send heroes to mine" />
          <TaskMenuButton name="recallmines" label="Recall Mines" />
          <TaskMenuButton
            name="shardstealer"
            label="Shard Stealer/Mine Booter"
          />
        </CustomNestedMenuItem>

        <TaskMenuButton
          name="downloadlbsevents"
          label="Download Leaderboards"
        />

        <CustomNestedMenuItem label="Reassign">
          <TaskMenuButton name="reassigntroops" label="Reassign Troops" />
          <TaskMenuButton name="reassignrss" label="Reassign Resources" />
        </CustomNestedMenuItem>

        <CustomNestedMenuItem label="SCHS">
          <TaskMenuButton name="openschsmaps" label="Open SCHS Maps" />
        </CustomNestedMenuItem>

        {true && (
          <CustomNestedMenuItem
            label={
              <>
                Custom Campaign Run
                <NEW />
              </>
            }
          >
            <TaskMenuButton
              name="echscustomrun"
              label={
                <>
                  Customised ECHS
                  <NEW />
                </>
              }
            />
            <TaskMenuButton
              name="chscustomrun"
              label={
                <>
                  Customised Normal CHS
                  <NEW />
                </>
              }
            />
            <TaskMenuButton
              name="schscustomrun"
              label={
                <>
                  Customised SCHS Run
                  <NEW />
                </>
              }
            />
          </CustomNestedMenuItem>
        )}
      </Menu>
    </>
  );
}

const NEW = () => {
  return <sup style={{ color: "red", paddingLeft: "10px" }}>NEW!</sup>;
};
